'use strict';

const 	ServiceFactory	= require('factories/Service')
		, ChatProvider	= new(require('providers/Chat'))()
		;

module.exports = ServiceFactory.create({
	displayName : 'Chat',
	methods : {
		getMessageUnreadCount : function({uuid, isHilda}){
			return ChatProvider.getMessageUnreadCount({uuid, isHilda: false}).then((result)=>{
				this.dispatch({
					type : 'CHAT_GET_MESSAGE_UNREAD_COUNT_SUCCESS',
					payload : result
				})
				return result;
			})
		},
		getHildaMessageUnreadCount : function({uuid}){
			return ChatProvider.getMessageUnreadCount({uuid, isHilda: true}).then((result)=>{
				this.dispatch({
					type : 'CHAT_GET_HILDA_MESSAGE_UNREAD_COUNT_SUCCESS',
					payload : result
				})
				return result;
			})
		},
	}
})



// WEBPACK FOOTER //
// providers/services/Chat.js